import { createContext, useContext } from "react";
import { type OnDocumentLoadSuccess } from "react-pdf/dist/shared/types.js";

export type FlyoutPdfContextState = {
  error?: boolean;
  file?: string;
  loading?: boolean;
  pageCount: number;
  pageCurrent: number;
  incrementPage: () => void;
  decrementPage: () => void;
  setPage: (page: number) => void;
  onLoadSuccess: OnDocumentLoadSuccess;
};

export const defaultFlyoutPdfContextState: FlyoutPdfContextState = {
  pageCount: 0,
  pageCurrent: 1,
  incrementPage: () => {},
  decrementPage: () => {},
  setPage: () => {},
  onLoadSuccess: () => {},
};

export const FlyoutPdfStateContext = createContext<FlyoutPdfContextState>(
  defaultFlyoutPdfContextState,
);
export const useFlyoutPdfState = () => useContext(FlyoutPdfStateContext);
